module.exports = require('./dist/react');



//////////////////
// WEBPACK FOOTER
// ./~/@storybook/addon-links/react.js
// module id = 1017
// module chunks = 0